import { render, staticRenderFns } from "./OutboundLoadStatus.vue?vue&type=template&id=ffdcf886&"
import script from "./OutboundLoadStatus.vue?vue&type=script&lang=js&"
export * from "./OutboundLoadStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports